import { RewardModalWrapper } from '@/components/reward-modal-wrapper';
import { CloseIcon } from '../svg-icons';
import { useState } from 'react';
import { useReward } from '@/contexts/reward-context';

export function SabaCoinRewardLevel() {
	const { labels, enableCoinRewardLevel, isValidPromotionVoucherUser } = useReward();
	const disableStorageKey = 'saba_reward_coin_level_closed';
	const [isClosed, setIsClosed] = useState(localStorage.getItem(disableStorageKey) === 'true');
	const [isClickBtn, setIsClickBtn] = useState(false);
	// ⚠️ isValidPromotionVoucherUser is temporarily for users without reward system, will be removed in the future
	const canShow = enableCoinRewardLevel && !isClosed && !isValidPromotionVoucherUser;
	
	const handleClose = () => {
		localStorage.setItem(disableStorageKey, 'true');
		setIsClosed(true);
	}

	const redirectToLevelInfo = () => {
		setIsClickBtn(true);

		document.dispatchEvent(new CustomEvent('show-saba-coin-reward-level-rule', {
			detail: { openRewardLevelRule: true }
		}));
		handleClose();
	}

	return canShow
		? (
			<RewardModalWrapper>
				<div className="reward-sbc-flow-level" >
					<div
						className="reward-modal-close__btn"
						onClick={handleClose}
					>
						<CloseIcon />
					</div>

					<div className="reward-sbc-flow-level__desc " >
						<div className="reward-sbc-flow-level__title reward-gradient-text">{labels?.lbl_newturnover01}</div>
						<div className="reward-sbc-flow-level__subtitle reward-gradient-text">
							{labels?.lbl_newturnover02}
							<br />
							{labels?.lbl_newturnover03}
						</div>
					</div>
					<div className="reward-receive__btn">

						<button
							className="reward-btn-3d "
							type="button"
							data-animate={isClickBtn ? 'true' : 'false'}
							onClick={redirectToLevelInfo}
						>
							<span className="reward-btn-3d__text">{labels?.lbl_newturnover04}</span>
							<div className="reward-btn-3d__bg"></div>
						</button>

					</div>

				</div>
			</RewardModalWrapper>
		) : null;
};